import {createContext} from "react"
import { makeAutoObservable,observable } from "mobx"
import {Packet,Park} from "./views/resAwareness/json/Park";
import { observer } from "mobx-react-lite"
import DF from "./views/system/DateFormat";
import Dict from "./views/resAwareness/json/Dict_Mizhan.json";
import {New} from "./views/system/Grammar";
// export const TimerContext = createContext({})

export const StoreContext = createContext({})

export class GlobalObState {

  mqttState = false;
  counter = 0;

  virtualMeter = 0;
  virtualSignal = 0;
  virtualRatio = 0.0;
  virtual_1_State = 0;
  virtual_2_State = 0;
  virtual_3_State = 0;
  virtual_4_State = 0;
  virtual_5_State = 0;
  virtual_6_State = 0;
  virtual_7_State = 0;
  virtual_8_State = 0;
  virtual_9_State = 0;

  gatewayList = []
  gateways = {}
  roomList = []
  rooms = {}
  terminalList = []
  terminals = {}
  iot = {}
  gtRooms = {}
  gtTerminals = {}
  rmTerminals = {}

  dataSets = {}
  users = {}

  realStep = 0;
  virtualStep = 0;
  alertToaster = [];
  secondsPassed = 0;
  currentTime = "";

  constructor() {makeAutoObservable(this)}

  obAll = (all) => {
    this.gateways = all["ambientJson"]
    this.gatewayList = all["ambientList"]
    this.rooms = all["roomJson"]
    this.roomList = all["roomList"]
    this.terminals = all["deviceJson"]
    this.terminalList = all["deviceList"]
    this.gtRooms = all["gtRooms"]
    this.gtTerminals = all["ambientDevice"]
    this.rmTerminals = all["roomDevice"]
  }

  obGateway = (gatewayJson) => this.gateways = Object.assign(this.gateways,gatewayJson)
  obRooms = (roomJson) => this.rooms = Object.assign(this.rooms,roomJson)
  obTerminals = (terminalJson) => this.terminals = Object.assign(this.terminals,terminalJson)

  obIot = (iotJson) => this.iot = Object.assign(this.iot,iotJson)
  obUsers = (userJson) => this.users = Object.assign(this.users,userJson)
  obDataSets = (dataSets) => this.dataSets = JSON.parse(JSON.stringify(dataSets))
  mqttConnect = (isConnected) => this.mqttState = isConnected

  counterRun = () => this.counter++
  virtualRun = () => {
    if(this.counter % 5 === 0){ //一般5秒更新状态
      this.virtualMeter = 1000*Math.random()
      this.virtualSignal = 10 * Math.random();
      let ts = new Date().getTime();
      VirtualSeqData["SEQ"] = {}
      VirtualSeqData["SEQ"][ts] = 10*Math.random()
      this.virtualRatio = 100 * Math.random()
      if(this.virtualStep === 17280) this.virtualStep = 0
      else this.virtualStep++

      this.virtual_2_State = this.virtualStep % 2;
      this.virtual_3_State = this.virtualStep % 3;
      this.virtual_4_State = this.virtualStep % 4;
      this.virtual_5_State = this.virtualStep % 5;
      this.virtual_6_State = this.virtualStep % 6;
      this.virtual_7_State = this.virtualStep % 7;
      this.virtual_8_State = this.virtualStep % 8;
      this.virtual_9_State = this.virtualStep % 9;
    }

    if(this.counter % 3 === 0){
      if(this.realStep === 28800) this.realStep = 0
      else this.realStep++
    }
  }
}

export class ResAware {

  curTs = ""
  foreTs = ""
  dict = {}

  generateData = (obj,type) => {
    switch (type){
      case 't': //变压器
        return parseFloat(obj.capacity)*(0.3*Math.random())
      case 'r': //新能源
        return parseFloat(obj.capacity)*(0.8*Math.random()) //装机容量的0%-80%之间
      case 'n':
        return 10*Math.random();
    }
  }

  dataSet = (packet,obj,type) => {
    let start = DF.formatTs("d"),now = packet.timeStamp,rollEnd = DF.timeMove("H+4","",now),
      foreStart = DF.formatTs("d",DF.timeMove("d+1")),foreEnd = DF.formatTs("d",DF.timeMove("d+2"));
    let ret = {
      state : {},
      history : {},
      foreValue : {},
      foreCurve : {},
      dayAheadCurve : {},
      rollCurve : {},
      K : {maxP:{},minP:{},maxDemand:{}},
      Cumulative : {}
    }
    while(start < now){ //生成历史数据
      ret["history"][start] = this.generateData(obj,type)
      start += packet.step
    }
    ret["state"][now] = this.generateData(obj,type) //生成实时数据
    ret["history"][now] = ret["state"][now]
    ret["foreCurve"][now] = ret["state"][now]
    ret["rollCurve"][now] = ret["state"][now]

    ret["foreValue"][now] = this.generateData(obj,type)
    // ret["foreCurve"][now] = this.generateData(obj,type) //生成预测数据，第一个数是预测曲线的起点
    let newNow = New(now) + packet.step,newRollNow = New(now) + packet.innerStep;

    while(newNow < foreStart){ //生成日内预测曲线
      ret["foreCurve"][newNow] = this.generateData(obj,type)
      newNow += packet.step
    }
    while(newRollNow < rollEnd){ //生成滚动预测曲线
      ret["rollCurve"][newRollNow] = this.generateData(obj,type)
      newRollNow += packet.innerStep
    }
    while (foreStart < foreEnd){ //生成日前预测曲线
      ret["dayAheadCurve"][foreStart] = this.generateData(obj,type)
      foreStart += packet.step
    }
    ret["Cumulative"] = { //生成累计电量
      hour: this.generateData(obj,type),
      day: 12*this.generateData(obj,type),
      week: 7*12*this.generateData(obj,type),
      month: 30*12*this.generateData(obj,type),
      year: 365*12*this.generateData(obj,type)
    }

    let merge = Object.assign(New(ret["history"]),New(ret["state"]))
    merge = Object.assign(merge,New(ret["foreCurve"]))
    // console.log(merge);
    Object.keys(merge).map(key=>{ //生成K线
      let value = merge[key],curMax = Object.values(ret["K"]["maxP"])[0]||0,
        curMin = Object.values(ret["K"]["minP"])[0]||999999
      if(value > curMax)ret["K"]["maxP"] = JSON.parse('{"'+key+'":'+value+'}')
      if(value < curMin)ret["K"]["minP"] = JSON.parse('{"'+key+'":'+value+'}')
      ret["K"]["maxDemand"] = ret["K"]["maxP"]
    })

    return ret
  }

  gData = (packet,park) => {
    park.nodes.map(n=>{
      n.transformer && n.transformer.map(t=>this.Assign(packet,t.key,this.dataSet(packet,t,'t')))
      n.renewablePower && n.renewablePower.map(r=>this.Assign(packet,r.key,this.dataSet(packet,r,'r')))
      this.Assign(packet,n.key,this.dataSet(packet,n,'n'))
    })
    return packet
  }

  Assign = (packet,key,value) => {
    packet["state"][key] = value["state"]
    packet["history"][key] = value["history"]
    packet["foreValue"][key] = value["foreValue"]
    packet["foreCurve"][key] = value["foreCurve"]
    packet["dayAheadCurve"][key] = value["dayAheadCurve"]
    packet["rollCurve"][key] = value["rollCurve"]
    packet["K"][key] = value["K"]
    packet["Cumulative"][key] = value["Cumulative"]
  }

  calStateInfo = (packet,park) => {
    packet.stateInfo = park.nodes.map(it=>{
      let v = Object.values(packet.state[it.key])[0]
      return `{${it.name} : ${v.toFixed(1) + "kW"}}`
    }).join(",")
    return packet;
  }

  generatePacket = (park,assign) => {
    this.curTs = assign??new Date().getTime()
    this.foreTs = this.curTs + park.step;
    let p = new Packet(park,assign)
    p = this.gData(p,park)
    p = this.calStateInfo(p,park)
    p.event = "push"
    return p;
  }
}

export const dataSets = observable({})
export const alertToaster = observable([])
export const behaviorToaster = observable([])

export const VirtualSeqData = observable({})
export const instance = new GlobalObState()
export const resInstance = new ResAware()
export const filterNodes = observable({observeNodes:[],peDataNodes:[],dtDataNodes:[], veDataNodes:[], ceDataNodes:[], oeDataNodes:[]})

export const gts = {}

setInterval(() => {
  instance.counterRun()
  instance.virtualRun()
}, 1000)

setTimeout(()=>{
  if(JSON.stringify(instance.gateways) === "{}") console.log("a");
  else {
    // FileSaver.saveAs(
    //   new Blob([JSON.stringify(instance.iot)], { type: 'text/plain;charset=utf-8' }),
    //   `sjtu.json`
    // );
  }
},10000)
